var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("Fields are definition of model for specific component. These fields are then available on create and edit page once they are added, also they are available through PublicAPI.")])])
}]

export { render, staticRenderFns }